import { tagFailure } from '@forest/paywall-core'
import { useStore } from '@nanostores/react'
import { useQuery } from '@tanstack/react-query'
import {
  getLatestSubscriptionLog,
  getServiceLevelStatus,
} from '~/services/api/user-service'
import { $userInfo } from '~/store/user-info'

export function useEntitlementQuery() {
  const userInfo = useStore($userInfo)
  const userId = userInfo?.user_id

  return useQuery({
    queryKey: ['entitlement', userId],
    queryFn: async () => {
      const [serviceLevelStatus, latestSubscriptionLog] = await Promise.all([
        getServiceLevelStatus(userId!),
        getLatestSubscriptionLog(userId!),
      ]).catch((error: unknown) => {
        throw tagFailure(error, 'load_service_level')
      })

      return {
        isSubscriber: serviceLevelStatus.service_level === 'subscription',
        isPremium: serviceLevelStatus.is_premium,
        latestSubscriptionExpiresAt: latestSubscriptionLog?.expires_at ?? null,
      }
    },
    enabled: !!userId,
    throwOnError: true,
  })
}
